import { createContext, ReactNode, useState } from "react";
import { Slide, ToastContainer, toast } from 'react-toastify';


type ToastContextProviderProps = {
  children: ReactNode;
}


type ToastContextType = {

  openToast: (type: 'success' | 'warning' | 'error', message: string, timeClose?: number) => void
  setToastPosition: (position: string) => void;
}

export const ToastContext = createContext({} as ToastContextType);


export function ToastContextProvider(props: ToastContextProviderProps) {
  const [toastPosition, setToastPosition] = useState<string>('0rem');
  function openToast(type: 'success' | 'warning' | 'error', message: string, timeClose?: number) {
    switch (type) {
      case "success":
        return toast.success(message, {
          position: "top-center",
          toastId: 'success1',
          autoClose: timeClose ? timeClose : 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      case "warning":
        return toast.warning(message, {
          position: "top-center",
          toastId: 'warning1',
          autoClose: timeClose ? timeClose : 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      case "error":
        return toast.error(message, {
          position: "top-center",
          toastId: 'error1',
          autoClose: timeClose ? timeClose : 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      default:
        return toast.success(message, {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
    }
  }

  return (
    <ToastContext.Provider value={{
      openToast,
      setToastPosition
    }}>
      <ToastContainer style={{
       
        width: '100%',
        maxWidth: '28rem',
        margin: '0 auto',
        boxSizing: 'border-box',
        padding: '0px'
      }} />
      {props.children}
    </ToastContext.Provider>
  )
}